import DropShippingRefundStatus from "@/enum/DropShippingRefundStatus";

const DropShippingRefundStatusNameMap = {
    [DropShippingRefundStatus.PENDING_REFUND]: "处理中-退款中",
};

export default DropShippingRefundStatusNameMap;
